export const MAX_NOTES = 200;

export const types = {
  NOTES_REQUEST: 'NOTES/NOTES_REQUEST',
  NOTES_SUCCESS: 'NOTES/NOTES_SUCCESS',
  NOTES_FAILURE: 'NOTES/NOTES_FAILURE',
};

export const initialState = {
  error: null,
  errorCode: null,
  isLoading: false,
  activeByRepo: {},
  resolvedByRepo: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.NOTES_REQUEST:
      return { ...state, isLoading: true, error: null, errorCode: null };
    case types.NOTES_SUCCESS:
      const { notes, isActive, repoUUID } = action;
      const stateKey = isActive ? 'activeByRepo' : 'resolvedByRepo';
      return {
        ...state,
        isLoading: false,
        [stateKey]: {
          ...state[stateKey],
          [repoUUID]: notes,
        },
      };
    case types.NOTES_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
        errorCode: action.errorCode,
      };
    default:
      return state;
  }
};

export const actions = {
  fetchNotes: (repoUUID, state) => ({
    type: types.NOTES_REQUEST,
    repoUUID,
    state,
  }),
};

export const selectors = {
  activeNotesForRepo: (state, repoUUID) => {
    return state.notes.activeByRepo[repoUUID];
  },
  resolvedNotesForRepo: (state, repoUUID) => {
    return state.notes.resolvedByRepo[repoUUID];
  },
};
